import React from "react";
import PropTypes from "prop-types";

/**
 * The block cursor that marks something live (accent) or static (muted);
 * `pulse` blinks it. Decorative: always aria-hidden.
 *
 * The pulse is a plain Tailwind `animate-pulse`; motion-reduce and the global
 * `prefers-reduced-motion` rule in src/styles/base.css both stop it.
 */
const StatusGlyph = ({ variant = "live", pulse = false, className = "" }) => {
	const colorClass = variant === "live" ? "text-pp-accent" : "text-pp-muted";
	const animClass = pulse ? "animate-pulse motion-reduce:animate-none" : "";
	return (
		<span
			aria-hidden="true"
			className={`font-mono inline-block leading-none ${colorClass} ${animClass} ${className}`.trim()}
		>
			▌
		</span>
	);
};

StatusGlyph.propTypes = {
	variant: PropTypes.oneOf(["live", "static"]),
	pulse: PropTypes.bool,
	className: PropTypes.string,
};

export default StatusGlyph;
